"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventBus = exports.createEventBus = void 0;
const ts_bus_1 = require("ts-bus");
const react_1 = require("react");
const bus = new ts_bus_1.EventBus();
const createEventBus = (eventName) => {
    const ourEvent = (0, ts_bus_1.createEventDefinition)()(eventName);
    return {
        subscribeFn: (fn) => bus.subscribe(ourEvent, event => fn(event.payload)),
        publishFn: (payload) => bus.publish(ourEvent(payload)),
    };
};
exports.createEventBus = createEventBus;
const useEventBus = (subscribeFn, defaultState) => {
    const [state, setState] = (0, react_1.useState)(defaultState);
    (0, react_1.useEffect)(() => {
        const unsub = subscribeFn(setState);
        return () => unsub();
    }, [subscribeFn]);
    return state;
};
exports.useEventBus = useEventBus;
//# sourceMappingURL=eventBus.js.map